export class KYMW0908OutputModel {
  // クーポン商品連番
  public couponGoodsNo = '';
  
  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードリスト
  public itemCodeList = [];

  // アイテムコードリストの活性制御
  public itemCodeListDisable = false;

  // クーポン種別
  public couponType = '';

  // クーポン種別名称
  public couponTypeName = '';

  // 注文コード割当
  public couponOrderNumQuotaCode = '';

  // 注文コード割当リスト
  public couponOrderNumQuotaCodeList = [];

  // 通知有無区分リスト
  public notificationFlgList: Array<any> = [
    {
      CodeValue: '0',
      CodeValueName: '0:通知無し'
    },
    {
      CodeValue: '1',
      CodeValueName: '1:通知有り'
    },
  ];
  // 通知有無区分
  public notificationFlg = '';

  // 通知有無区分名称
  public notificationFlgName = '';

  // 職員用クーポンフラグ
  public staffCouponFlg = '';

  // クーポン名
  public couponName = '';

  // クーポン名（ｶﾅ）
  public couponNameKana = '';

  // クーポン規格名
  public couponGuideName = '';

  // クーポン規格名（ｶﾅ）
  public couponGuideNameKana = '';

  // グループ
  public groupType = '';

  // クーポン注文コード
  public couponOrderNum = '';

  // 通知方法お届け明細フラグ
  public deliveryFlg = '';

  // 通知方法お届け明細フラグ名称
  public deliveryFlgName = '';

  // 通知方法メルマガフラグ
  public newsletterFlg = '';

  // 通知方法メルマガフラグ名称
  public newsletterFlgName = '';

  // 値引情報区分
  public couponDiscountType = '1';

  // 値引単価（一括設定）
  public couponDiscountUnitPrice = '';

  // 値引率（一括設定）
  public couponDiscountRate = '';

  // 制限数（一括設定）
  public couponLimitNum = '';

  // 会員生協別値引情報一覧
  public couponApplicablePriceList = [];

  // タイトル（EC）
  public couponTitleEc = '';

  // タイトル（お届け明細）
  public couponTitleDelivery = '';

  // 内容1（商品名・規格）
  public contentOne = '';

  // 内容2（値引き前本体価格・税込み価格）
  public contentTwo = '';

  // 内容3（値引き内容）
  public contentThree = '';

  // 内容4（値引き後本体価格・税込み価格）
  public contentFour = '';

  // 有効期限
  public validatedDate = '';

  // 追加フラグ
  public registFlg = '0';

  // 削除フラグ
  public deleteFlg = '0';
}
